import moment from 'moment'
import { getCurrentLanguage } from './config'

export const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const convertHoursToDays = numberOfHours => {
  const days = Math.floor(numberOfHours / 24);
  return days;
};

export const isToday = date => {
  const now = moment(moment().format('MM/DD/YYYY'));
  return now.diff(date, 'days') === 0;
};

export const isSameDay = (date1, date2) => {
  const year = moment().format('YYYY');
  const yearDate1 = moment(date1).format('YYYY');
  if (year !== yearDate1) {
    date1 = `${year}-${date1}`;
  }
  date1 = moment(moment(date1).format('MM/DD/YYYY'));
  date2 = moment(moment(date2).format('MM/DD/YYYY'));
  return date1.diff(date2, 'days') === 0;
};

export const getDayFormat = date => {
  const momentDate = moment(date);
  let dateFormatted = momentDate.locale(getCurrentLanguage()).format('LL');
  if (isToday(momentDate)) {
    dateFormatted = 'Aujourd\'hui';
  }
  return dateFormatted;
};

export const formatPromotionDate = (dateString) => {
  return moment(dateString).locale('fr').format('LL');
};

export const getDateFormat = date => {
  return moment(date)
    .locale(getCurrentLanguage())
    .format('LLL');
};

export const formatEstimationTime = (estimationTime) => {
  let estimationTimeFormat = '';
  let estimationDayFormat = '';
  let estimationTimeFormatWithMargin = '';
  if (estimationTime) {
    const isToday = estimationTime.isSame(Date.now(), 'day');
    estimationTimeFormat = `${estimationTime.format('HH:mm').replace(':', 'h')}`;
    estimationTimeFormatWithMargin = isToday ? `entre ${estimationTimeFormat} - ${estimationTime.clone().add(20, 'minutes').format('HH:mm').replace(':', 'h')}` : estimationTimeFormat;
    estimationDayFormat = isToday ? 'Aujourd\'hui' : `${estimationTime.clone().locale('fr').format('LL')}`;
  }

  return {
    estimationTimeFormat,
    estimationDayFormat,
    estimationTimeFormatWithMargin
  };
};